import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";
import { db } from "../firebase/firebase";

export default function ContactMessagesPage() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  // 📥 Fetch Messages
  const fetchMessages = async () => {
    try {
      const q = query(
        collection(db, "contactMessages"),
        orderBy("createdAt", "desc")
      );

      const snapshot = await getDocs(q);

      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setMessages(data);
    } catch (error) {
      console.error("Error fetching messages:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  return (
    <div className="min-h-screen p-6">
      <div className="max-w-7xl mx-auto shadow-lg rounded-2xl p-6">

        {/* 🔷 Heading */}
        <h2 className="text-2xl font-bold mb-6 text-gray-80">
          Contact Messages
        </h2>

        {/* ⏳ Loading */}
        {loading ? (
          <p className="text-center text-gray-500 py-10">
            Loading messages...
          </p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-200 rounded-xl overflow-hidden">

              {/* 🧠 Head */}
              <thead className="bg-gray-100 text-gray-600 text-sm uppercase">
                <tr>
                  <th className="px-4 py-3 border">Name</th>
                  <th className="px-4 py-3 border">Email</th>
                  <th className="px-4 py-3 border">Subject</th>
                  <th className="px-4 py-3 border">Coupon</th>
                  <th className="px-4 py-3 border">Message</th>
                  <th className="px-4 py-3 border">Status</th>
                  <th className="px-4 py-3 border">Date</th>
                </tr>
              </thead>

              {/* 📊 Body */}
              <tbody>
                {messages.length === 0 ? (
                  <tr>
                    <td
                      colSpan="6"
                      className="text-center py-6 text-gray-500"
                    >
                      No messages found
                    </td>
                  </tr>
                ) : (
                  messages.map((msg) => (
                    <tr
                      key={msg.id}
                      className="hover:bg-gray-50 transition"
                    >
                      <td className="px-4 py-3 border font-medium text-gray-800">
                        {msg.name}
                      </td>

                      <td className="px-4 py-3 border text-blue-600">
                        {msg.email}
                      </td>

                      <td className="px-4 py-3 border text-gray-700">
                        {msg.subject}
                      </td>

                      <td className="px-4 py-3 border text-gray-700">
                        {msg.couponCode} - {msg.couponName}
                      </td>

                      <td className="px-4 py-3 border text-gray-600 max-w-xs truncate">
                        {msg.message}
                      </td>

                      <td className="px-4 py-3 border">
                        <span
                          className={`px-3 py-1 text-xs rounded-full font-medium ${msg.status === "new"
                            ? "bg-green-100 text-green-700"
                            : "bg-gray-200 text-gray-700"
                            }`}
                        >
                          {msg.status}
                        </span>
                      </td>

                      <td className="px-4 py-3 border text-sm text-gray-500">
                        {msg.createdAt
                          ? new Date(
                            msg.createdAt.seconds * 1000
                          ).toLocaleString()
                          : ""}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}